<template>
    <div
        class="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3"
        data-spec-class="card_list-grid-skeleton"
    >
        <BaseCardListSkeleton
            v-for="index in size"
            :key="index"
            data-spec-class="card_list-grid-skeleton__card"
        />
    </div>
</template>

<script lang="ts" setup>
import { defineProps, withDefaults } from 'vue';

interface Props {
    size?: number;
}

withDefaults(defineProps<Props>(), {
    size: 4,
});
</script>
